import type { Session } from 'src/shared/session';

export function getViewerPageStateData(session: Session | undefined): unknown {
	if (!session) {
		return undefined;
	}

	const { user, loginState, uuid } = session;

	return {
		user: user
			? {
					id: user.id,
					displayName: user.displayName,
					photo: user.photo,
					totalSignatureCount: user.totalSignatureCount,
				}
			: undefined,
		loginState,
		uuid,
	};
}
